import api from "@/services/api";
import { Promise } from "core-js";
import route from "@/router/index";

const BASE_URL = "/kasbon/settlement-kasbons";

//#region state
const state = {
  settlementKasbons: [],
  lastFormNumber: null,
  settlementKasbon: {},
  listSettlementKasbon: [],
};
//#endregion

//#region getters
const getters = {};
//#region

//#region actions
const actions = {
  async create(context, body) {
    try {
      const response = await api.post(BASE_URL, body);
      if (response.status === 200) {
        context.dispatch(
          "toast",
          { type: "success", message: "Success Saved Data" },
          { root: true }
        );
        route.push({ name: "Detail Settlement Kasbon", params: { id: response.data } });
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async createExternal(context, body) {
    try {
      const response = await api.post(BASE_URL, body);
      if (response.status === 200) {
        context.dispatch(
          "toast",
          { type: "success", message: "Success Saved Data" },
          { root: true }
        );
        route.push({ name: "External Settlement Print", params: { id: response.data } });
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async createMulti(context, body) {
    try {
      const response = await api.post(`${BASE_URL}/multi`, body);
      if (response.status === 200) {
        context.dispatch(
          "toast",
          { type: "success", message: "Success Saved Data" },
          { root: true }
        );
        return Promise.resolve(response);
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async createMultiPerEmployee(context, body) {
    try {
      const response = await api.post(`${BASE_URL}/multi-per-employee`, body);
      if (response.status === 200) {
        context.dispatch(
          "toast",
          { type: "success", message: "Success Saved Data" },
          { root: true }
        );
        return Promise.resolve(response);
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async createNoKasbon(context, body) {
    try {
      const response = await api.post(`${BASE_URL}/no-kasbon`, body);
      if (response.status === 200) {
        context.dispatch(
          "toast",
          { type: "success", message: "Success Saved Data" },
          { root: true }
        );
        route.push({ name: "Detail Settlement Kasbon", params: { id: response.data } });
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async createExternalNoKasbon(context, body) {
    try {
      const response = await api.post(`${BASE_URL}/no-kasbon`, body);
      if (response.status === 200) {
        context.dispatch(
          "toast",
          { type: "success", message: "Success Saved Data" },
          { root: true }
        );
        route.push({ name: "External Settlement Print", params: { id: response.data } });
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getLastFormNumber(context) {
    try {
      const response = await api.get(`${BASE_URL}/form-number`);
      if (response.status === 200) {
        let num = null;
        let date = new Date();
        if (response.data === "New") {
          num = `SK.${date.getFullYear()}.${date.getMonth() + 1}.00001`;
        } else {
          const lastNumber = response.data ? response.data.split(".")[3] : "";
          const ctx = "" + (parseInt(lastNumber) + 1);
          const end = lastNumber.substr(0, lastNumber.length - ctx.length) + ctx;
          num = `SK.${date.getFullYear()}.${date.getMonth() + 1}.${end}`;
        }
        context.commit("SET_LAST_FORM_NUMBER", num);
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getAll(context, params) {
    try {
      const response = await api.get(`${BASE_URL}`, params);

      if (response.status === 200) {
        context.commit("SET_SETTLEMENT_KASBONS", response.data);
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getById(context, id) {
    try {
      const response = await api.get(`${BASE_URL}/${id}`);
      // if (response.status === 200) {
      //   context.commit("SET_SETTLEMENT_KASBON", response.data);
      // }
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async update(context, body) {
    try {
      const response = await api.put(`${BASE_URL}/${body.id}`, body);
      if (response.status === 200) {
        window.location.reload();
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async delete(context, id) {
    try {
      const response = await api.deleted(`${BASE_URL}/${id}`);
      if (response.status === 200) {
        route.push({ name: "Settlement Kasbon" });
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getListSettlementKasbon() {
    try {
      const response = await api.get(`${BASE_URL}/dropdown`);
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getChecklist() {
    try {
      const response = await api.get(`${BASE_URL}/checklist`);
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getApproval() {
    try {
      const response = await api.get(`${BASE_URL}/approval`);
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async saveChecklist(context, body) {
    try {
      const response = await api.post(`${BASE_URL}/checklist`, body);
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async saveApproval(context, data) {
    try {
      const response = await api.post(`${BASE_URL}/approval`, data.body, {
        params: { bulk: data.bulk, pin: data.pin },
      });
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getDocument(context, data) {
    try {
      const response = await api.post(`${BASE_URL}/document`, data);
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async downloadDocument(context, data) {
    try {
      const response = await api.post(`${BASE_URL}/document/download`, data, {
        responseType: "blob",
      });
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async downloadSingleDocument(context, id) {
    try {
      const response = await api.get(`${BASE_URL}/document/download/${id}`, {}, "blob");
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getSettlementDetailByWoId(context, params) {
    try {
      const response = await api.get(`${BASE_URL}/detail/wo/${params.wo}`, {
        employeeId: params.employeeId,
      });
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },
};
//#endregion

//#region mutations
const mutations = {
  SET_LAST_FORM_NUMBER(state, payload) {
    state.lastFormNumber = payload;
  },
  SET_SETTLEMENT_KASBON(state, payload) {
    state.settlementKasbon = payload;
  },
  SET_SETTLEMENT_KASBONS(state, payload) {
    state.settlementKasbons = payload;
  },
  SET_LIST_SETTLEMENT_KASBON(state, payload) {
    state.listSettlementKasbon = payload;
  },
};
//#endregion

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
